// extracted by mini-css-extract-plugin
export default {"modal":"organizationModal_modal__kcsCI","classes":"organizationModal_classes__tj0aq","tag":"organizationModal_tag__KoEuv"};